//-- Copyright (c) 2021 TMT Insights Group, LLC
import FileTypeDisplay from '@/components/_common/FileTypeDisplay';
import { IngestFile } from '@/redux/slices/slice_types';
import { insertWordBreaks, formatBytes } from '../../_utils/utils';
import DateTimeDisplay from '../_common/DateTimeDisplay';
import IngestManagementOverflowMenu from './IngestManagementOverflowMenu';
import IngestRegister from './IngestRegister/IngestRegister';
import { Grid } from '@mui/material';
import PolarisIcon from '../_common/PolarisIcon';
import { TableStatus } from '@/exports/columnCommonComponents';

export default {
  hid: {
    label: 'ID',
    field: 'hid',
    sortField: 'id'
  },
  created_at: {
    label: 'Created',
    render: (cell: string) => <DateTimeDisplay>{cell}</DateTimeDisplay>
  },
  srcBucket: {
    label: 'Bucket',
    field: 'src_bucket',
    sortField: 'src_bucket',
    disableSort: true
  },
  filePath: {
    label: 'Filename',
    field: 'filename',
    sortField: 'filename',
    minWidth: 500,
    render: (cell: string) => <strong>{insertWordBreaks(cell) || ''}</strong>
  },
  fileType: {
    label: 'File Type',
    field: 'file_type',
    sortField: 'file_type',
    render: (cell: string) => <FileTypeDisplay type={cell} />,
    disableSort: false
  },
  file_size: {
    label: 'File Size',
    disableSort: true,
    render: (cell: IngestFile['file_size']) => {
      return cell ? (
        <Grid container alignItems="center">
          <PolarisIcon icon="clarity:hard-disk-solid" height={20} style={{ marginRight: 5, opacity: 0.6 }} />
          {formatBytes(cell)}
        </Grid>
      ) : (
        '-'
      );
    }
  },
  // file_size: {
  //   label: 'File Size',
  //   render: (cell: number) => <span style={{ whiteSpace: 'nowrap' }}>{cell ? formatBytes(cell) : '-'}</span>
  // },
  version_id: {
    label: 'Version',
    disableSort: true
  },
  status: {
    label: 'Status',
    render: (cell: string, row: IngestFile) => (
      // only display status reason if status is failed or in_error
      <TableStatus status={cell} statusReason={(row.status && (row.status === 'failed' || row.status === 'in_error') && row.status_reason) || ''} />
    ),
    disableSort: false
  },
  register: {
    label: 'Action',
    width: 30,
    render: (_: any, row: IngestFile) => <IngestRegister data={row} />,
    disableSort: true
  },
  overflow: {
    label: '',
    isOverflow: true,
    render: (_: any, row: IngestFile) => <IngestManagementOverflowMenu data={row} />
  }
};
